export default "__VITE_ASSET__DHqfjdqx__"